import React, { useState } from 'react';
import { Eye, EyeOff, Check, Circle } from 'lucide-react';

export const REGLAS_CONTRASENA = [
  { id: 'largo', texto: 'Al menos 8 caracteres', cumple: (v) => v.length >= 8 },
  { id: 'mayuscula', texto: 'Una letra mayúscula', cumple: (v) => /[A-ZÁÉÍÓÚÑ]/.test(v) },
  { id: 'minuscula', texto: 'Una letra minúscula', cumple: (v) => /[a-záéíóúñ]/.test(v) },
  { id: 'especial', texto: 'Un carácter especial (!@#$%…)', cumple: (v) => /[^A-Za-z0-9ÁÉÍÓÚÑáéíóúñ\s]/.test(v) }
];

export const contrasenaValida = (v) => REGLAS_CONTRASENA.every(r => r.cumple(v));

const CampoContrasena = ({ id, value, onChange, invalido, autoComplete = 'new-password', ...resto }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`flex rounded-lg border focus-within:ring-2 ${
      invalido ? 'border-red-300 focus-within:ring-red-400' : 'border-gray-300 focus-within:ring-blue-500'
    }`}>
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        aria-invalid={invalido || undefined}
        className="flex-1 min-w-0 px-3 py-2 text-sm rounded-l-lg outline-none"
        {...resto}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        aria-pressed={visible}
        className="px-3 text-gray-400 hover:text-gray-600 rounded-r-lg outline-none focus-visible:text-blue-600"
      >
        {visible ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};

export const RequisitosContrasena = ({ value }) => (
  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 mt-2" aria-live="polite">
    {REGLAS_CONTRASENA.map(r => {
      const ok = r.cumple(value);
      return (
        <li key={r.id} className={`flex items-center gap-1.5 text-xs ${ok ? 'text-green-700' : 'text-gray-500'}`}>
          {ok ? <Check size={13} strokeWidth={3} /> : <Circle size={11} className="text-gray-300" />}
          {r.texto}
        </li>
      );
    })}
  </ul>
);

export default CampoContrasena;
